export namespace ExplorerTestIds {
    export const Explorer = 'tb-content-explorer';
    export const ExplorerBusySpinner = 'explorer-view-busy';
    export const ExplorerNoContent = 'tb-spaces-no-content';
    export const ExplorerNoContentFilters = 'tb-spaces-no-content-filters';
    export const ExplorerMainArea = 'explorer-main-area';
    export const ExplorerContentArea = 'explorer-content-area';
}